import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import HoverInfoIcon from '~src/shared/tooltips/HoverInfoIcon';
import AvatarBox, { AvatarType } from '~src/shared/avatarBox/AvatarBox';

export const TileHeaderContainer = styled.header<{ $border?: boolean }>`
  display: flex;
  padding: 20px 30px;
  border-bottom: ${({ $border, theme }) => ($border ? `1px solid ${theme.black.a1}` : 0)};
  align-items: center;

  &.with-bg {
    background-color: ${({ theme }) => theme.white.a10};
    border-top-left-radius: ${({ theme }) => theme.misc.tileBRadius};
    border-top-right-radius: ${({ theme }) => theme.misc.tileBRadius};
    box-shadow: ${({ theme }) => theme.misc.tileShadow};
  }
`;

const Title = styled.span.attrs({ className: 'hl3' })`
  margin: 0 5px 0 0;
`;

const AvatarWrapper = styled.div`
  margin-right: 15px;
`;

interface Props {
  title: string | ReactNode;
  titleKey?: string;
  tooltip?:
    | {
        txt: string;
        key: string;
      }
    | string;
  border?: boolean;
  avatar?: {
    size?: number;
    type: AvatarType;
    url?: string | null;
    name: string;
  };
  withBg?: boolean;
}

const TileHeader: FC<Props> = React.memo(function TileHeader({ title, titleKey, tooltip, border, avatar, withBg }) {
  return <TileHeaderContainer $border={border} className={withBg ? 'with-bg' : ''}>
    {avatar && (
      <AvatarWrapper>
        <AvatarBox size={avatar.size || 33} type={avatar.type} url={avatar.url} name={avatar.name}/>
      </AvatarWrapper>
    )}
    <Title data-translation={titleKey}>{title}</Title>
    {tooltip && <HoverInfoIcon infoText={tooltip} maxWidth={'unset'} />}
  </TileHeaderContainer>;
});

export default TileHeader;
